<template lang="en">
<div class="ctrl-100 ctrl">
    <el-button class="ctrl-btn" :class="{active: broadcastMessageFormVisible}" @click="toggleVisibility" type="text">
        <IconBase
            class='ctrl-icon'
            :height="32"
            :width="32"
            :view-box="`0 0 32 32`"
            :fill="'#E7E6FA'"
        >
            <IconBrodcast />
        </IconBase>
        Broadcast
    </el-button>
    <div class="ctrl-window__overlay" v-if="broadcastMessageFormVisible" @click="broadcastMessageFormVisible = false"></div>
    <transition name="fade">
        <div class="ctrl-window" v-if="broadcastMessageFormVisible" width="30%">
            <div class="ctrl__header">
                <h3 class="ctrl__title">Broadcast message</h3>
                <div @click="broadcastMessageFormVisible=false">
                    <IconBase
                        :height="24"
                        :width="24"
                        :view-box="`0 0 24 24`"
                        :fill="'#E7E6FA'"
                    >
                        <IconCross />
                    </IconBase>
                </div>
            </div>
            <div lang='en'>
                <el-form @submit.prevent.native="sendMessage" :model="broadcastMessage" class="ctrl__form">
                    <el-row>
                        <el-input
                            type="textarea"
                            v-model="broadcastMessage.message"
                            size="small"
                            placeholder="Type your message"
                            class="brodcast-input"
                        >
                        </el-input>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="ctrl__footer">
                <el-button @click="cancelBroadCastMessageForm">Cancel</el-button>
                <el-button type="primary" @click="sendMessage">Post</el-button>
            </span>
        </div>
    </transition>

</div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";
import IconBase from "../IconBase";
import IconBrodcast from "../icons/IconBrodcast";
import { mapState, mapGetters } from "vuex";
import IconCross from "../icons/IconCross";
import { getSocketPayload, JITSI_CONSTANTS } from "../../utils";

export default {
  name: "BroadcastMessage",
  components: {
    Icon,
    IconBrodcast,
    IconBase,
    IconCross
  },

  data: function() {
    return {
      broadcastMessageFormVisible: false,
      broadcastMessage: {
        message: ""
      }
    };
  },

  methods: {
    toggleVisibility() {
      this.broadcastMessageFormVisible = !this.broadcastMessageFormVisible;
    },
    sendMessage() {
      this.broadcastMessageFormVisible = false;
      this.socket.emit(
        "BROADCAST_MESSAGE",
        getSocketPayload({
          token: this.tokens ? this.tokens["idToken"] : null,
          mainRoom: this.mainRoom.name,
          userName: this.name || JITSI_CONSTANTS.defaultDisplayName,
          eventName: this.mainRoom._id + "BROADCAST_MESSAGE",
          message: this.broadcastMessage.message
        })
      );
      this.broadcastMessage.message = "";
    },
    cancelBroadCastMessageForm: function() {
      this.broadcastMessageFormVisible = false;
      this.broadcastMessage.message = "";
    }
  },
  computed: {
    ...mapState({
      name: state => state.rooms.name,
      mainRoom: state => state.rooms.mainRoom,
      tokens: state => state.user.tokens
    }),
    ...mapGetters("rooms", {
      socket: "getSocket"
    })
  }
};
</script>

<style scoped>
.broadcast-message {
  fill: #f7f7f7;
}

.broadcast-message:hover,
.broadcast-message-active {
  fill: #409eff;
}
.ctrl-icon {
  display: block;
}
>>> .el-textarea__inner {
  height: 96px;
  color: #e7e6fa;
}
</style>
